import script from "./ModalRyuyoDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalRyuyoDetails.vue?vue&type=script&setup=true&lang=ts"

import "./ModalRyuyoDetails.vue?vue&type=style&index=0&id=28ba3785&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28ba3785"]])

export default __exports__